const HeroSection = () => {
    return (
      <section className="relative w-full h-[800px]">
        <div className="absolute inset-0">
          <div className="w-full h-full bg-gallery-page-hero bg-center bg-cover"></div>
        </div>

        <div className="absolute inset-0 bg-[#A77F43] bg-opacity-60 flex items-center justify-center">
          <div className="w-[80%] lg:w-[60%] flex flex-col justify-center items-center mt-[100px] lg:px-[10%]">
            <h1 className="text-[60px] xs:text-[50px] sm:text-[80px] xl:text-[100px] font-bold font-playfair text-[#F5E9D7] text-center">GALLERY</h1>
            <p className="xs:text-[20px] text-[25px] xl:text-[22px] font-medium font-montserrat text-[#F5E9D7] text-center mt-8">
                Discover the artistry, passion, and love that go into crafting every delightful treat at Symphony's Artisanal Bakery
            </p>
          </div>
        </div>
      </section>
    );
  };
  
  export default HeroSection;